import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { screenResize } from '../ui-action';

/**
 * A Subset HOC of window-resize that only provides the device type. This should reduce the number of re-renders
 * @param {} Component 
 */
const DeviceChange = (Component) => {
    return class extends React.PureComponent {
        componentDidMount() {
            const { resize, width, height } = this.props;
            if (!width || !height) {
                let { innerWidth, innerHeight } = window;
                resize(innerWidth, innerHeight);
            }
        }

        render() {
            return <Component {...this.props} />;
        }
    };
};

const mapStateToProps = (state) => ({
    device: state.ui.device
    //TODO add custom breakpoints. But would need to first figure out how to memoize it, since it's currently returning a new Object everytime
});
const mapDispatchToProps = (dispatch) => ({
    resize: (width, height) => dispatch(screenResize(width, height)),
});

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    DeviceChange
);
